// Tysiąc: the points the game is played to, picked in the Games window (owner 2026-10-28: to 500 or to 1000, in a
// drop-down list like 3-5-8's lengths, saved the moment it is picked). Kept in the browser (a long game's New game
// reloads the page).
import { DEFAULT_TARGET, TARGETS } from '../1000/rules';

const KEY = 'solitaire_storage:1000-target';

export function picked1000Target(): number {
  try {
    const n = Number(localStorage.getItem(KEY));
    return (TARGETS as readonly number[]).includes(n) ? n : DEFAULT_TARGET;
  } catch {
    return DEFAULT_TARGET;
  }
}

export function pick1000Target(n: number): void {
  try {
    localStorage.setItem(KEY, String(n));
  } catch {
    // no storage (a private window): the pick lasts until the page reloads
  }
}
